import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getHomeData } from "../../redux/actions/dataActions";
import Banner from "../banner/Banner";
import Details from "../details/Details";
import Notification from "../notification/Notification";
import Box from "@mui/material/Box";
import UtiBox from "../chartStatus/box/UtiBox";

import "./Home.css";
import ChartStatus from "../chartStatus/ChartStatus";
import Documents from "../documents/Documets";
import OrderDetails from "../orderDetails/OrderDetails";
import Carousel from "react-material-ui-carousel";
import { open } from "../../redux/actions/modalActions";

function Home() {
  const { data } = useSelector((state) => state.data);
  const dispatch = useDispatch();
  
  useEffect(() => {
    if (!data) {
      dispatch(getHomeData());
    } 
  }, []);

  useEffect(() => {
    if (data?.messageContent && !data?.notificationStatus) {
      dispatch(open('notif'));
    }
  }, [data])
  
  const isMobile = window.innerWidth <= 760;
  const [titles, setTitles] = useState({
    paymentSection: "תשלום",
    buildingSection: "הכנת הרכב",
    qualityControlSection: "רישוי ובקרת איכות",
    deliverySection: "מסירה",
  });

  const numberOfSteps = data && data.isLic ? 4 : 3;

  const [items, setItems] = useState({
    paymentSection: data?.type == 'Leasing' ? ["inStockDate", "paymentDate", "shiabudRequestData"] : ["inStockDate", "shiabudRequestData", "paymentDate"],
    buildingSection: [
      "welcomeDate",
      "sirtutSignDate",
      "hovaInsur",
      "pdiDate",
      "buildingDate",
      "extraDate",
    ],
    qualityControlSection: ["Lic", "qualtiCtrlDate"],
    deliverySection: ["deliveryAppoint", "shildaFormSignDate", "deliveryDate"],
  });

  const steps = () => {
    return (
      data &&
      [
        "paymentSection",
        "buildingSection",
        "qualityControlSection",
        "deliverySection",
      ].map((key) => {
        if (data[key]) {
          if (data && data.isLic) {
            let number = 100 / 4;
            return <UtiBox torLink={data?.torLink} width={number + "%"} orderType={data?.orderType} type={data?.type} data={data[key]} title={titles[key]} items={items[key]} />
          } else {
            let number = 100 / 3;
            return <UtiBox torLink={data?.torLink} width={number + "%"} orderType={data?.orderType} type={data?.type} data={data[key]} title={titles[key]} items={items[key]} />
          }
        }
        return null;
      })
    );
  };
  
  return (
    <div dir="rtl" className="home-warp">
      <Box className="row banner_row">
        <Banner
          modelName={data?.modelName}
          orderType={data?.orderType}
          boxLength={data?.boxLength}
          brand={data?.brand}
          boxType={data?.boxType}
          type={data?.type}
          customerName={data?.customerName}
        />
      </Box>
      
      <Box className="row notifAndDetails" id="status">
        {data?.messageContent ? <Notification 
          data={{
            popupType: data?.popupType,
            messageContent: data?.messageContent,
            popupUrls: data?.popupUrls
          }} /> : ''}
        <Details
          data={{
            mail: data?.userMail,
            name: data?.userName,
            tel: data?.userTel,
          }}
          title={"מנהל תיקי לקוחות"}
        />
        <Details
          data={{
            mail: data?.cordinatorMail,
            name: data?.cordinatorName,
            tel: data?.cordinatorTel,
          }}
          title={"מתאמת שירות אישית"}
        />
      </Box>
      <Box className="row chart-box bg-gray">
        <ChartStatus
          data={{
            ...data?.deliverySection,
            
            shiduhDate: data?.shiduhDate,
            deliveryExpected: data?.deliveryExpected,
            step: data?.step,
            innerPercentage: data?.innerPercentage,
            numberOfSteps : numberOfSteps,
          }}
        />

        <Box className="uti_box_row">
          {isMobile ? (
            <Carousel
              selectedItem={steps()?.length - 1}
              autoPlay={false}
              index={data?.step - 1 || 0}
              navButtonsAlwaysInvisible={true}
            >
              {steps()?.filter(item => item !== undefined && item !== null)}
            </Carousel>
          ) : (
            <>{steps()}</>
          )}
        </Box>
      </Box>

      <Box className="row" id="documents">
        <Documents docs={data?.documents} />
      </Box>
      <Box id="order-details" className="row  bg-gray">
        {data && <OrderDetails data={data} />}
      </Box>
    </div>
  );
}

export default Home;
